/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


/**
 * **Required Permission(s):** ORG_CLAIM_LIST
 */
export const listOpportunityClaimsQueryPageDefault = 1;export const listOpportunityClaimsQueryPageSizeDefault = 25;

export const listOpportunityClaimsQueryParams = zod.object({
  "page": zod.number().default(listOpportunityClaimsQueryPageDefault),
  "pageSize": zod.number().default(listOpportunityClaimsQueryPageSizeDefault),
  "claimStatuses": zod.array(zod.enum(['Claimed', 'Approved', 'Rejected', 'Expired', 'Withdrawn', 'PayoutRequested', 'Returned'])).optional(),
  "startDate": zod.string().datetime({}).optional(),
  "endDate": zod.string().datetime({}).optional(),
  "talentIds": zod.array(zod.string().uuid()).optional()
})

export const listOpportunityClaimsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "opportunityId": zod.string().uuid(),
  "numberOfUnits": zod.number().nullish(),
  "claimedBy": zod.string().uuid(),
  "claimerName": zod.string(),
  "claimDate": zod.string().datetime({}),
  "approvedBy": zod.string().uuid().nullish(),
  "approvalDate": zod.string().datetime({}).nullish(),
  "rejectedBy": zod.string().uuid().nullish(),
  "rejectionReason": zod.string().nullish(),
  "rejectionDate": zod.string().datetime({}).nullish(),
  "claimExpiryDate": zod.string().datetime({}).nullish(),
  "status": zod.enum(['Claimed', 'Approved', 'Rejected', 'Expired', 'Withdrawn', 'PayoutRequested', 'Returned']),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid().optional(),
  "modifiedByUserId": zod.string().uuid().optional()
})),
  "totalCount": zod.number(),
  "page": zod.number(),
  "pageSize": zod.number(),
  "totalPages": zod.number(),
  "hasNextPage": zod.boolean(),
  "hasPreviousPage": zod.boolean()
})

/**
 * **Required Permission(s):** ORG_CLAIM_LIST
 */
export const getClaimTimelineParams = zod.object({
  "id": zod.string().uuid()
})

export const getClaimTimelineResponseItem = zod.object({
  "id": zod.string().uuid(),
  "opportunityClaimId": zod.string().uuid(),
  "payoutRequestId": zod.string().uuid().nullish(),
  "eventName": zod.string(),
  "eventTypeName": zod.string(),
  "actorUserId": zod.string().uuid().nullish(),
  "actorName": zod.string().nullish(),
  "details": zod.string().nullish(),
  "occurredAt": zod.string().datetime({})
})
export const getClaimTimelineResponse = zod.array(getClaimTimelineResponseItem)

/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_GET
 */
export const getClaimTimelineDetailParams = zod.object({
  "id": zod.string().uuid()
})

export const getClaimTimelineDetailResponse = zod.object({
  "claim": zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "opportunityId": zod.string().uuid(),
  "numberOfUnits": zod.number().nullish(),
  "claimedBy": zod.string().uuid(),
  "claimerName": zod.string(),
  "claimDate": zod.string().datetime({}),
  "approvedBy": zod.string().uuid().nullish(),
  "approvalDate": zod.string().datetime({}).nullish(),
  "rejectedBy": zod.string().uuid().nullish(),
  "rejectionReason": zod.string().nullish(),
  "rejectionDate": zod.string().datetime({}).nullish(),
  "claimExpiryDate": zod.string().datetime({}).nullish(),
  "status": zod.enum(['Claimed', 'Approved', 'Rejected', 'Expired', 'Withdrawn', 'PayoutRequested', 'Returned']),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid().optional(),
  "modifiedByUserId": zod.string().uuid().optional()
}),
  "currentPayoutRequest": zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "payee": zod.object({
  "type": zod.enum(['User', 'Organization']),
  "id": zod.string().uuid()
}),
  "payeeName": zod.string(),
  "quantity": zod.number(),
  "amount": zod.number().nullish(),
  "status": zod.enum(['Pending', 'Returned', 'Denied', 'Approved']),
  "workflow": zod.enum(['Opportunity', 'FsmGenerated', 'TalentMemberGenerated', 'StaffMemberGenerated']),
  "canBeReturned": zod.boolean(),
  "payoutSetupStatus": zod.enum(['OrganizationRelationshipNeeded', 'NotStarted', 'IdentityVerificationPending', 'PayoutMethodNeeded', 'BankAccountAwaitingReview', 'BankAccountRejected', 'BankAccountUnlinked', 'BankAccountReturned', 'DebitCardNotPayoutEligible', 'DebitCardPayoutsUnavailable', 'Ready']),
  "isPaymentEligible": zod.boolean(),
  "hasApprovedNonPrimaryBankAccount": zod.boolean(),
  "reviewedByUserId": zod.string().uuid().nullish(),
  "reviewerName": zod.string().nullish(),
  "reviewedDate": zod.string().datetime({}).nullish(),
  "reviewNotes": zod.string().nullish(),
  "approvalMethod": zod.enum(['Administrator', 'PreApproved', 'AutoApproved']).optional(),
  "evidence": zod.object({
  "id": zod.string().uuid(),
  "payoutRequestId": zod.string().uuid(),
  "text": zod.string().nullish(),
  "documents": zod.array(zod.object({
  "id": zod.string().uuid(),
  "blobUrlId": zod.string().uuid(),
  "url": zod.string(),
  "hash": zod.string(),
  "contentType": zod.string().nullish(),
  "fileSize": zod.number().nullish(),
  "createdDate": zod.string().datetime({})
})),
  "references": zod.array(zod.object({
  "id": zod.string().uuid(),
  "label": zod.string(),
  "referenceValue": zod.string(),
  "createdDate": zod.string().datetime({})
})),
  "gpsCheckins": zod.array(zod.object({
  "id": zod.string().uuid(),
  "gpsCoordinateId": zod.string().uuid(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "accuracy": zod.number().nullish(),
  "note": zod.string().nullish(),
  "createdDate": zod.string().datetime({})
})),
  "createdDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid().nullish()
}).optional(),
  "invoice": zod.object({
  "id": zod.string().uuid(),
  "number": zod.number(),
  "status": zod.enum(['Draft', 'Finalized', 'Paid', 'Voided'])
}).optional(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid().nullish(),
  "modifiedByUserId": zod.string().uuid().nullish(),
  "concurrencyToken": zod.string()
}).optional(),
  "payoutRequestHistory": zod.array(zod.object({
  "id": zod.string().uuid(),
  "amount": zod.number(),
  "quantity": zod.number(),
  "status": zod.enum(['Pending', 'Returned', 'Denied', 'Approved']),
  "payeeName": zod.string(),
  "reviewerName": zod.string().nullish(),
  "reviewedDate": zod.string().datetime({}).nullish(),
  "reviewNotes": zod.string().nullish(),
  "createdDate": zod.string().datetime({}),
  "invoice": zod.object({
  "id": zod.string().uuid(),
  "number": zod.number(),
  "status": zod.enum(['Draft', 'Finalized', 'Paid', 'Voided'])
}).optional()
}))
})

